export default __webpack_public_path__ + "static/media/bigLogo.fa508b8b.png";